<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>미납주차요금</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">미납주차요금</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link></li>
            <li>
              <router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link>
            </li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">미납요금 납부안내</p>
          <ul class="depth">
            <li><router-link to="/unpaidinfo" title="미납요금 납부안내">미납요금 납부안내</router-link></li>
            <li>
              <router-link to="/lookupunpaid" title="미납요금 조회/결제"
                >미납요금 조회/결제</router-link
              >
            </li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">미납요금 납부안내</h3>
        <article>
          <p class="subTitle">주차요금 징수목적</p>
          <div class="infoBox">공영주차장 이용시 사용자부담 원칙에 의한 주차료 징수를 통한 주차장 이용 문화 정착</div>
        </article>
        <article>
          <p class="subTitle">미납요금 고지대상</p>
          <ol class="bullet numType">
            <li class="num01">정당한 사유 없이 주차요금을 납부하지 않을 경우(임의 출차 등)</li>
            <li class="num02">주차장 운영시간 중 주차관리원과 주차 요금을 정산하지 못한 경우</li>
            <li class="num03">주차장 운영 종료 시간까지 출차 하지 않은 경우</li>
          </ol>
        </article>
        <article>
          <p class="subTitle">미납요금 납부안내</p>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table blue-table col20">
              <table>
                <caption>
                  미납요금 납부안내 테이블
                </caption>
                <colgroup>
                  <col style="width: 10%" />
                  <col style="width: 40%" />
                  <col style="width: auto" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">미납유형</th>
                    <th scope="col">납부방법</th>
                  </tr>
                </thead>
                <tbody>
                <tr>
                  <td rowspan="5">노상주차장</td>
                  <td class="txt-left">당일 주차장 운영시간 이후 출차</td>
                  <td class="txt-left">차량에 부착된 미납요금 납부 안내서에 기재 된 계좌로 입금</td>
                </tr>
                <tr>
                  <td class="txt-left">당일 부득이한 사정으로 주차 요금 납부하지 못하고 출차</td>
                  <td class="txt-left">차량에 부착된 입차증 하단에 안내된 전화번호로 문의 후 납부</td>
                </tr>
                <tr>
                  <td class="txt-left" rowspan="3">
                    당일 이전에 이용한 미납(체납) <br>
                    (당일 미납요금 제외)
                  </td>
                  <td class="txt-left">이천시시설관리공단에서 운영하는 주차장의 모든 주차관리원에게 즉시 조회 및 즉시 납부 가능</td>
                </tr>
                <tr>
                  <td class="txt-left">이천 스마트 주차포털에서 미납요금 조회 및 결제가능</td>
                </tr>
                <tr>
                  <td class="txt-left">카카오톡 알림톡을 통한 미납요금 안내 고지서 확인 및 열람 후 납부 가능</td>
                </tr>
                <tr>
                  <td rowspan="2">노외주차장</td>
                  <td class="txt-left" rowspan="2">당일 부득이한 사정으로 주차요금 납부하지 못하고 출차</td>
                  <td class="txt-left">
                    무인 정산기에서 미납내역 조회 후 납부 혹은 미납으로 인해 받은 문자서비스(SMS)에 기재 된 가상계좌로 입금
                  </td>
                </tr>
                <tr>
                  <td class="txt-left">이천 스마트 주차포털에서 미납요금 조회 및 결제가능</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <p class="info">
            입금자명 잘못 기재 시, 입금확인 불가 하오니, 공영주차장 사무실(031-635-2070)로 전화하여 확인 바랍니다.
          </p>
          <p class="info">
            운영시간 종료 후에는 전산등록이 완료되어 요금 수납이 불가 하오니 위의 내용을 참고하시어 납부하여 주시기
            바랍니다.
          </p>
          <p class="info">가상계좌 납부기한은 발행 후 최대 30 일까지이며, 고지된 납부기한 초과 시 수납이 불가합니다.</p>
          <p class="info">주차요금 미납(체납)시 가산금 부과 및 차량 압류와 같은 불이익이 발생할 수 있습니다.</p>
        </article>
        <article>
          <p class="subTitle">미납요금 고지절차</p>
          <!--stepArea-->
          <div class="unpaidStep web">
            <ul>
              <li>
                <div class="box"  style="height: 239px;">
                  <span class="step01">현장고지</span>
                  <p>노상주차장: 미납안내서<br /></p>
                  <p>노외주차장: 미납안내서<br />또는 문자(SMS) 고지</p>
                </div>
                <strong>원금부과</strong>
              </li>
              <li>
                <div class="box">
                  <span class="step02">1차 고지</span>
                  <p>모바일 전자고지<br />(카카오톡) 발송</p>
                </div>
                <strong class="colorType black">원금부과</strong>
              </li>
              <li>
                <div class="box">
                  <span class="step02">2차 고지</span>
                  <p>일반우편으로<br />발송</p>
                </div>
                <strong class="colorType black"><strong class="colorType pink2">납기내</strong> -원금부과</strong>
                <strong class="colorType black"
                  ><strong class="colorType pink2">납기후</strong> -원금+가산금<br />200% 합산부과</strong
                >
              </li>
              <li>
                <div class="box">
                  <span class="step03">3차 고지</span>
                  <p>일반우편으로<br />발송</p>
                </div>
                <strong class="colorType black">원금+가산금<br />200% 합산부과</strong>
              </li>
              <li>
                <div class="box">
                  <span class="step04">압류예정 통보서</span>
                  <p>등기우편으로<br />발송</p>
                </div>
                <strong class="colorType black">원금+가산금<br />200% 합산부과</strong>
              </li>
              <li>
                <div class="box">
                  <span class="step05">압류등록</span>
                  <p>압류 등록 후<br />차량 압류</p>
                </div>
                <strong class="colorType black">지방세 기본법<br />제91조</strong>
              </li>
            </ul>
          </div>
          <div class="unpaidStep mobile">
            <ul>
              <li>
                <div class="box" style="height: 239px;">
                  <span class="step01">1차 고지</span>
                  <p>노상주차장:<br />미납안내서<br /></p>
                  <p>노외주차장:<br />미납안내서<br />또는 문자(SMS) 고지</p>
                </div>
                <strong>원금부과</strong>
              </li>
              <li>
                <div class="box">
                  <span class="step02">2차 고지</span>
                  <p>일반우편으로<br />발송</p>
                </div>
                <strong class="colorType black"><strong class="colorType pink2">납기내</strong> -원금부과</strong>
                <strong class="colorType black"
                  ><strong class="colorType pink2">납기후</strong> -원금+가산금<br />200% 합산부과</strong
                >
              </li>
              <li>
                <div class="box">
                  <span class="step03">압류예정 통보서</span>
                  <p>등기우편으로<br />발송</p>
                </div>
                <strong class="colorType black">원금+가산금<br />200% 합산부과</strong>
              </li>
              <li>
                <div class="box">
                  <span class="step04">3차 고지</span>
                  <p>일반우편으로<br />발송</p>
                </div>
                <strong class="colorType black">원금+가산금<br />200% 합산부과</strong>
              </li>
              <li>
                <div class="box">
                  <span class="step05">압류등록</span>
                  <p>압류 등록 후<br />차량 압류</p>
                </div>
                <strong class="colorType black">지방세 기본법<br />제91조</strong>
              </li>
            </ul>
          </div>
          <!--//stepArea-->
        </article>
        <!-- 테이블 추가 -->
        <article>
          <p class="subTitle">미납 주차요금 가산금 부과 안내</p>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table blue-table col20">
              <table>
                <caption>
                  미납 주차요금 가산금 부과 안내
                </caption>
                <colgroup>
                  <col style="width: 10%" />
                  <col style="width: 40%" />
                  <col style="width: auto" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">구분</th>
                    <th scope="col">미납 주차요금</th>
                    <th scope="col">가산금(200%)</th>
                    <th scope="col">총 부과요금</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>예시</td>
                    <td>1,000원</td>
                    <td>2,000원</td>
                    <td>3,000원</td>
                  </tr>
                  <tr>
                    <td>예시</td>
                    <td>2,000원</td>
                    <td>4,000원</td>
                    <td>6,000원</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </article>
        <article>
          <p class="subTitle">주차요금 및 가산금 부과 법적 근거</p>
          <ol class="bullet numType">
            <li class="num01">[주차장법] 제9조, 제14조</li>
            <li class="num02">[이천시 주차장 설치 및 관리 조례] 제5조, 제10조</li>
          </ol>
        </article>
        <article>
          <p class="subTitle">미/체납요금 관련 문의</p>
          <div class="infoBox">이천시 시설관리공단 주차사업팀 031)635-2070</div>
        </article>
        <article>
          <div class="btnArea">
            <button type="button" class="btn blue" @click="$router.push('/lookupunpaid')">주차요금 미납결제</button>
          </div>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  mounted() {},

  methods: {},
};
</script>
